var productCardMarkup = `  <ul class="product-grid row">
    {{#products}}
    <li class="col-xs-6 col-sm-3">
      
        <div class="card-wrapper">
            <a href="{{du}}" class="full-unstyled-link">
                <span class="visually-hidden">{{dt}}</span>
                <div class="card card__product tabindex="-1">
                    <div class="card__inner">
                        <div>
                        {{vendor}}
                            <div class="media media--transparent media--portrait media--hover-effect">
                            <img class="motion-reduce lazyload lazyautosizes" src="{{iu}}">
                            </div>
                        </div>
                        <div class="card__badge">
                        </div>
                        <div class="card__buttons">
                        <button class="remove-button swym-remove-product-tile" data-product-id="{{empi}}" data-variant-id="{{epi}}">${window.productStrings.close}</button>
                        </div>
                    </div>
                </div>
                <div class="card-information">
                    <div class="card-information__wrapper">
                        <span class="visually-hidden">${window.productStrings.vendor}</span>
                        <div class="caption light">{{vendor}}</div>
                        <span class="card-information__text h4">
                            {{dt}} {{vi}}
                        </span>
                        <div class="price {{#sale}}price--on-sale{{/sale}}">
                            <div class="price__regular">
                                <dt>
                                    <span class="visually-hidden visually-hidden--inline">${window.productStrings.regular_price}</span>
                                </dt>
                                <dd>
                                    <span class="price-item price-item--regular">
                                        {{price}}
                                    </span>
                                </dd>
                            </div>
                            <div class="price__sale">
                                <dt class="price__compare">
                                    <span class="visually-hidden visually-hidden--inline">${window.productStrings.regular_price}</span>
                                </dt>
                                <dd class="price__compare">
                                    <s class="price-item price-item--regular">
                                    {{compare_at_price}}
                                    </s>
                                </dd>
                                <dt>
                                    <span class="visually-hidden visually-hidden--inline">${window.productStrings.sale_price}</span>
                                </dt>
                                <dd class="price__last">
                                    <span class="price-item price-item--sale">
                                    {{price}}
                                    </span>
                                </dd>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            {{^isOOS}} <a class="link add-to-cart" data-product-id="{{empi}}" data-url="{{du}}"data-variant-id="{{epi}}" href="{{#isInCart}}${window.routes.cart_url}{{/isInCart}}">{{#isInCart}}${window.productStrings.added_to_cart}{{/isInCart}} {{^isInCart}}${window.productStrings.add_to_cart}{{/isInCart}}</a> {{/isOOS}}
            {{#isOOS}}{{/isOOS}}
    </li>
    {{/products}}
  </ul>`;
var __wishlistedProducts = [];

function swymCallbackFn(swat) {
    //re-route default url.
    SwymUtils.getHostedURL = function () {å
        return "/pages/wishlist?";
    }
    //fetch wishlisted products
    swat.fetch(function (products) {
        __wishlistedProducts = products;
        console.time("Initial Wishlist Fetched and Rendered");
        if (products.length > 1) {
            document.querySelector('.wishlist__warnings').remove();
        } else {
            document.querySelector('.wishlist-container').classList.add('is-empty');
        }
        render(swat, products, false);
        attachClickListeners(false); // false skips notify me events.
        updateOOSProducts(swat, products);
        console.timeEnd("Initial Wishlist Fetched and Rendered");
    }, window._swat.EventTypes.addToWishList);
}

function render(swat, products, isNotifyBtn) {
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    if (wishlistContentsContainer) {
        var formattedWishlistedProducts = products.map(function (p) {
            p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
            p.isInCart = swat.platform.isInDeviceCart(p.epi) || (p.et == swat.EventTypes.addToCart);
            p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
            return p;
        });
        var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
            products: formattedWishlistedProducts
        });
        wishlistContentsContainer.innerHTML = productCardsMarkup;
    }
}
if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

function updateOOSProducts(swat, products) {
    fetchCompleteProductMeta(swat, products, function (updatedProducts) {
        console.time("Second Render Update OOS Products");
        render(swat, updatedProducts);
        attachClickListeners(true);
        console.timeEnd("Second Render Update OOS Products");
    });
}

function fetchCompleteProductMeta(swat, products, callback) {
    //fetch and update avalabile variants.  
    products.forEach(function (product, index) {
        var params = {
            epi: product.epi,
            empi: product.empi,
            du: product.du
        };
        swat.getProductDetails(params, function (productJSON) {
            products.forEach(function (p) {
                
                if (p.empi == productJSON.id) {
                    p.vendor = productJSON.vendor;

                    //get variant availablity
                    productJSON.variants.forEach(function (variant) {
                        if (p.epi == variant.id && !variant.available) {
                            p.isOOS = !variant.available; // add your OOS variant logic here.
                            p.price = Shopify.formatMoney(variant.price, theme.moneyFormat);
                            p.compare_at_price = Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat);
                            if (variant.compare_at_price > variant.price) {
                                p.sale = true;
                            }
                            callback(products); //update the product that was just recieved.
                            // console.timeEnd("Updated! Product for OOS");
                        }
                    });
                }
            });
        });
    });
}

function getVariantInfo(variants) {
    try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
            variantinfo;
        if (variantKeys.length > 0) {
            variantinfo = variantKeys[0];
            if (variantinfo == "Default Title") {
                variantinfo = "";
            }
        } else {
            variantinfo = "";
        }
        return variantinfo;
    } catch (err) {
        return variants;
    }
}

function onAddToCartClick(e) {
    if (e.target.href != window.location.href) {
        return false;
    }
    e.preventDefault();

    var productId = e.target.getAttribute("data-product-id");
    var variantId = e.target.getAttribute("data-variant-id");
    var du = e.target.getAttribute("data-url");
    e.target.innerHTML = "..";
    window._swat.replayAddToCart({
        empi: productId,
        du: du
    }, variantId, function () {
        e.target.innerHTML = window.productStrings.added_to_cart;
        e.target.href = window.routes.cart_url;
    }, function (e) {
        console.log(e);
        e.target.innerHTML = "Error!..";
    });
}

function attachClickListeners(isNotifyEvents) {
    var addToCartButtons = document.getElementsByClassName("add-to-cart");
    var removeProductButtons = document.querySelectorAll(".swym-remove-product-tile");
    // Add to cart
    for (var i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
        addToCartButtons[i].classList.add("swym-loaded-atc");
    };
    // Remove products
    for (var i = 0; i < removeProductButtons.length; i++) {
        removeProductButtons[i].addEventListener('click', onRemoveProductClick, false);
    };
    // Notify events
    if (isNotifyEvents) {
        var notifyMeBtns = document.querySelectorAll(".swym-notify-me");
        notifyMeBtns.forEach(function (notifyBtn) {
            notifyBtn.onclick = addToWatchListProduct;
        });
    }
}

function onRemoveProductClick(event) {
    event.preventDefault();
    var productId = event.target.getAttribute("data-product-id");
    var variantId = event.target.getAttribute("data-variant-id");
    __wishlistedProducts.forEach(function (p) {
        if (p.empi == productId && p.epi == variantId) {
            window._swat.removeFromWishList(p, function (r) {
                event.target.closest('li').remove();
            });
        }
    });
}

function addToWatchListProduct(e) {
    e.preventDefault();
    var productId = e.target.getAttribute("data-product-id");
    var variantId = e.target.getAttribute("data-variant-id");
    //   Loop and find with the previously saved product data.
    __wishlistedProducts.forEach(function (product) {
        if (product.empi == productId && product.epi == variantId) {
            let productObj = product;
            productObj.et = 8; // event type 8 stands for registering a "notify me" event.
            window._swat.addToWatchList(e, productObj, function (r) {
            }, document.querySelector(".INJECT-FORM"));
            return;
        }
    });
}